// extracted by mini-css-extract-plugin
export default {"submitButton":"style_submitButton__Nu18u"};